import { useTheme } from '@features/theme';
import { Flex } from '@radix-ui/themes';
import styles from './BrandLogo.module.css';

function BrandLogo() {
    const { reverseTheme } = useTheme();

    return (
        <Flex
            justify={'center'}
            align={'center'}
            width={'100%'}
            height={'100%'}
            m={'1'}
            mt={'0'}
        >
            <img
                className={styles.image}
                src={`/images/logo/eclair-${reverseTheme}.svg`}
            />
        </Flex>
    );
}

export default BrandLogo;
